import { render, staticRenderFns } from "./ProjectTop.vue?vue&type=template&id=32d07c41&scoped=true&"
import script from "./ProjectTop.vue?vue&type=script&lang=js&"
export * from "./ProjectTop.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTop.vue?vue&type=style&index=0&id=32d07c41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d07c41",
  null
  
)

export default component.exports